import { IProduct } from '~/types/serviceTypes';

export const products: IProduct[] = [
    {
        name: 'Authorized Generic of EPCLUSA<sup>\u00AE</sup> (sofosbuvir 400 mg/velpatasvir 100 mg) tablet',
        ndc: '72626-2701-01',
        promoId: [2274, 2303, 2286],
        dropTo: 'L-DRIVE',
        program: 'Asegua',
    },
    {
        name: 'Authorized Generic of HARVONI<sup>\u00AE</sup> (ledipasvir 90 mg/sofosbuvir 400 mg) tablet',
        ndc: '72626-2601-01',
        promoId: [2274, 2303, 2286],
        dropTo: 'L-DRIVE',
        program: 'Asegua',
    },
    {
        name: 'BIKTARVY<sup>\u00AE</sup> (bictegravir 50 mg/emtricitabine 200 mg/tenofovir alafenamide 25 mg) tablet (Bottle)',
        ndc: '61958-2501-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'BIKTARVY<sup>\u00AE</sup> (bictegravir 50 mg/emtricitabine 200 mg/tenofovir alafenamide 25 mg) tablet (Blister Pack)',
        ndc: '61958-2501-3',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'BIKTARVY<sup>\u00AE</sup> (bictegravir 30 mg/emtricitabine 120 mg/tenofovir alafenamide 15 mg) tablet (Bottle)',
        ndc: '61958-2505-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    // {
    //     name: 'BIKTARVY<sup>\u00AE</sup> (bictegravir 30 mg/emtricitabine 120 mg/tenofovir alafenamide 15 mg) tablet (Bottle)',
    //     ndc: '61958-2506-1',
    //     promoId: [2247],
    //     dropTo: 'L-DRIVE',
    //     program: 'Gilead',
    // },
    {
        name: 'BIXLENVO<sup>\u2122</sup> (bictegravir 75 mg/lenacapavir 50 mg) tablets',
        ndc: '61958-3601-1',
        promoId: [6980],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'CAYSTON<sup>\u00AE</sup> (aztreonam for inhalation solution 75 mg) vial',
        ndc: '61958-0901-1',
        promoId: [2249],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'COMPLERA<sup>\u00AE</sup> (emtricitabine 200 mg/rilpivirine 25 mg/ tenofovir disoproxil fumarate 300 mg) tablet',
        ndc: '61958-1101-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'DESCOVY<sup>\u00AE</sup> (emtricitabine 200 mg/tenofovir alafenamide 25 mg) tablet (Bottle)',
        ndc: '61958-2002-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'DESCOVY<sup>\u00AE</sup> (emtricitabine 200 mg/tenofovir alafenamide 25 mg) tablet (Blister Pack)',
        ndc: '61958-2002-2',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'DESCOVY<sup>\u00AE</sup> (emtricitabine 120 mg/tenofovir alafenamide 15 mg) tablet',
        ndc: '61958-2005-01',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'EMTRIVA<sup>\u00AE</sup> (emtricitabine 200 mg) capsule',
        ndc: '61958-0601-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'EMTRIVA<sup>\u00AE</sup> (emtricitabine 10 mg/mL) oral solution',
        ndc: '61958-0602-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'EPCLUSA<sup>\u00AE</sup> (sofosbuvir 400 mg/velpatasvir 100 mg) tablet',
        ndc: '61958-2201-1',
        promoId: [2246, 2256, 2264],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'EPCLUSA<sup>\u00AE</sup> (sofosbuvir 200 mg/velpatasvir 50 mg) tablet',
        ndc: '61958-2203-1',
        promoId: [2246, 2256, 2264],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'EPCLUSA<sup>\u00AE</sup> (sofosbuvir 200 mg/velpatasvir 50 mg) oral pellet',
        ndc: '61958-2204-01',
        promoId: [2246, 2256, 2264],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'EPCLUSA<sup>\u00AE</sup> (sofosbuvir 150 mg/velpatasvir 37.5 mg) oral pellet',
        ndc: '61958-2205-01',
        promoId: [2246, 2256, 2264],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'GENVOYA<sup>\u00AE</sup> (elvitegravir 150 mg/cobicistat 150 mg/emtricitabine 200 mg/tenofovir alafenamide 10 mg) tablet',
        ndc: '61958-1901-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'HARVONI<sup>\u00AE</sup> (ledipasvir 90 mg/sofosbuvir 400 mg) tablet',
        ndc: '61958-1801-1',
        promoId: [2250, 2257, 2263],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'HARVONI<sup>\u00AE</sup> (ledipasvir 45 mg/sofosbuvir 200 mg) tablet',
        ndc: '61958-1803-1',
        promoId: [2250, 2257, 2263],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'HARVONI<sup>\u00AE</sup> (ledipasvir 45 mg/sofosbuvir 200 mg) oral pellet',
        ndc: '61958-1804-1',
        promoId: [2250, 2257, 2263],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'HARVONI<sup>\u00AE</sup> (ledipasvir 33.75 mg/sofosbuvir 150 mg) oral pellet',
        ndc: '61958-1805-1',
        promoId: [2250, 2257, 2263],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'HEPCLUDEX<sup>\u00AE</sup> (bulevirtide-gmod) 8.5 mg/vial, 30 single-dose vials',
        ndc: '61958-3104-01',
        promoId: [3581],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'LETAIRIS<sup>\u00AE</sup> (ambrisentan 10 mg) tablet, 30 ct',
        ndc: '61958-0802-1',
        promoId: [2271],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'LETAIRIS<sup>\u00AE</sup> (ambrisentan 5 mg) tablet, 30 ct',
        ndc: '61958-0801-1',
        promoId: [2271],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'LIVDELZI<sup>\u00AE</sup> (seladelpar 10 mg) capsule',
        ndc: '61958-3301-01',
        promoId: [4933],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'LIVDELZI<sup>\u00AE</sup> (seladelpar 10 mg) capsule (blister pack)',
        ndc: '61958-3301-02',
        promoId: [4933],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'ODEFSEY<sup>\u00AE</sup> (emtricitabine 200 mg/rilpivirine 25 mg/tenofovir alafenamide 25 mg) tablet',
        ndc: '61958-2101-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'SOVALDI<sup>\u00AE</sup> (sofosbuvir 400 mg) tablet',
        ndc: '61958-1501-01',
        promoId: [2251, 2254, 2262],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'SOVALDI<sup>\u00AE</sup> (sofosbuvir 200 mg) tablet',
        ndc: '61958-1503-01',
        promoId: [2251, 2254, 2262],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'SOVALDI<sup>\u00AE</sup> (sofosbuvir 200 mg) oral pellet',
        ndc: '61958-1505-01',
        promoId: [2251, 2254, 2262],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'SOVALDI<sup>\u00AE</sup> (sofosbuvir 150 mg) oral pellet',
        ndc: '61958-1504-01',
        promoId: [2251, 2254, 2262],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'STRIBILD<sup>\u00AE</sup> (elvitegravir 150 mg/cobicistat 150 mg/emtricitabine 200 mg/tenofovir disoproxil fumarate 300 mg) tablet',
        ndc: '61958-1201-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'SUNLENCA<sup>\u00AE</sup> (lenacapavir 300 mg) tablets, 4-count (Bottle)',
        ndc: '61958-3001-3',
        promoId: [3427, 3428, 6980],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'SUNLENCA<sup>\u00AE</sup> (lenacapavir 300 mg) tablets, 4-count (Blister Pack)',
        ndc: '61958-3001-1',
        promoId: [3427, 3428],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'SUNLENCA<sup>\u00AE</sup> (lenacapavir 300 mg) tablets, 5-count (Blister Pack)',
        ndc: '61958-3001-2',
        promoId: [3427, 3428],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'SUNLENCA<sup>\u00AE</sup> (lenacapavir-463.5 mg/1.5 mL) vial for injection',
        ndc: '61958-3005-1',
        promoId: [3427, 3428],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'TRODELVY<sup>\u00AE</sup> (sacituzumab govitecan-hziy 180 mg) for injection',
        ndc: '55135-0132-01',
        promoId: [3702, 3692],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'TRUVADA<sup>\u00AE</sup> (emtricitabine 200 mg/tenofovir disoproxil fumarate 300 mg) tablet',
        ndc: '61958-0701-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'TRUVADA<sup>\u00AE</sup> (emtricitabine 167 mg/tenofovir disoproxil fumarate 250 mg) tablet',
        ndc: '61958-0705-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'TRUVADA<sup>\u00AE</sup> (emtricitabine 133 mg/tenofovir disoproxil fumarate 200 mg) tablet',
        ndc: '61958-0704-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'TRUVADA<sup>\u00AE</sup> (emtricitabine 100 mg/tenofovir disoproxil fumarate 150 mg) tablet',
        ndc: '61958-0703-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'TYBOST<sup>\u00AE</sup> (cobicistat 150 mg) tablet',
        ndc: '61958-1401-1',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'TYBOST<sup>\u00AE</sup> (cobicistat 90 mg) tablet',
        ndc: 'not-available',
        promoId: [2247],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'VEMLIDY<sup>\u00AE</sup> (tenofovir alafenamide 25 mg) tablet',
        ndc: '61958-2301-1',
        promoId: [2245],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'VOSEVI<sup>\u00AE</sup> (sofosbuvir 400 mg/velpatasvir 100 mg/voxilaprevir 100 mg) tablet',
        ndc: '61958-2401-1',
        promoId: [2248, 2225, 2261],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'YEZTUGO<sup>\u00AE</sup> (lenacapavir 300 mg) tablet',
        ndc: '61958-3401-01',
        promoId: [6283],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'YEZTUGO<sup>\u00AE</sup> (lenacapavir 463.5 mg/1.5 mL) vial for injection',
        ndc: '61958-3402-01',
        promoId: [6283],
        dropTo: 'QP',
        program: 'Gilead',
    },
    {
        name: 'ZYDELIG<sup>\u00AE</sup> (idelalisib 100 mg) tablet',
        ndc: '61958-1701-1',
        promoId: [2244],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
    {
        name: 'ZYDELIG<sup>\u00AE</sup> (idelalisib 150 mg) tablet',
        ndc: '61958-1702-1',
        promoId: [2244],
        dropTo: 'L-DRIVE',
        program: 'Gilead',
    },
];

export default products;
